import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const DiscoverStepTwoExtraCollections = ({
  discoverStepTwoExtraCollections,
  discoverStepTwoExtraCurrency,
  getCollections,
  hasLoaded,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="discover-collections-container--step-two-extra"
      currency={discoverStepTwoExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={discoverStepTwoExtraCollections}
      levelsPath={paths.DISCOVER_STEP_TWO_EXTRA_LEVELS}
      student={student}
      title={messages.game.discover}
    />
  );
};

DiscoverStepTwoExtraCollections.propTypes = {
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  discoverStepTwoExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  discoverStepTwoExtraCurrency: PropTypes.shape({}).isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.discoverStepTwoExtraCollections.getHasLoaded(state),
  discoverStepTwoExtraCollections: selectors.discoverStepTwoExtraCollections.getCollectionsData(
    state
  ),
  discoverStepTwoExtraCurrency: selectors.discoverStepTwoExtraCollections.getCurrencyData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.discoverStepTwoExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(DiscoverStepTwoExtraCollections);
